const BASE_URL = process.env.REACT_APP_API_URL;

export const BASE_SUPPLIER_ONBOARD = BASE_URL + 'v1/supplier-onboard';
export const REGISTER_URL = BASE_SUPPLIER_ONBOARD + '/register';
export const UPLOAD_KTP_URL = BASE_SUPPLIER_ONBOARD + '/upload-ktp';
export const UPLOAD_PRICELIST_URL = BASE_SUPPLIER_ONBOARD + '/upload-pricelist';
export const REGISTERED_SUPPLIER_ID_URL = (registrationCode) => BASE_SUPPLIER_ONBOARD + `/${registrationCode}`;

export const CREATE_SAMPLE_URL = ({supplierOnboardId}) => BASE_SUPPLIER_ONBOARD + `/create-sample/${supplierOnboardId}`;
export const UPLOAD_DOCUMENT_URL = ({supplierOnboardId}) => BASE_SUPPLIER_ONBOARD + `/upload-supplier-onboard-doc/${supplierOnboardId}`;
export const SAMPLE_ID_URL = (sampleId) => BASE_SUPPLIER_ONBOARD + `/sample/${sampleId}`;

export const INVENTORY_DASHBOARD_V1 = BASE_URL + 'v1/inventory';
export const PRODUCT_TAG_PREFIX_NAME_V1 = (prefixName) => BASE_URL + 'v1/product-tags/prefixName/' + prefixName;

export const WAREHOUSE_V1 = BASE_URL + '/warehouses/v1';

export const REGION_CLOUDALERT = 'https://alamat.thecloudalert.com/api';
export const PROVINCE = REGION_CLOUDALERT + '/provinsi/get/';
export const CITY = (provinceId) => REGION_CLOUDALERT + '/kabkota/get/?d_provinsi_id=' + `${provinceId}`;
export const DISTRICT = (cityId) => REGION_CLOUDALERT + '/kecamatan/get/?d_kabkota_id=' + `${cityId}`;
export const ZIPCODE = (cityId, districtId) => REGION_CLOUDALERT + '/kodepos/get/?d_kabkota_id=' + `${cityId}` + '&d_kecamatan_id=' + `${districtId}`;

export const PURCHASE_ORDER_V1_1 = BASE_URL + 'v1.1/purchase-orders';
export const ASN_V1 = BASE_URL + 'v1/asn';